import React, { useState, useEffect } from 'react'

import { isStringURL } from 'helpers/miscellaneous'
import { navigate } from 'helpers/navigation'
import { extractRoomNameFromURL } from 'helpers/room'

import {
    OuterWrapper,
    Wrapper,
    LogoWrapper,
    Logo,
    ActionWrapper,
    Button,
    WelcomeText,
    SubText,
    InputWrapper,
    InputField,
    ValidationError,
} from './styles'

/*
== Enter Room Id Screen == 
*/
const EnterRoomId = props => {
    const [inputValue, setInputValue] = useState('')
    const [isValidRoomId, setIsValidRoomId] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const handleRoomIdChange = e => {
        setInputValue(e.target.value)
    }

    const onBlur = e => {
        let value = e.target.value
        const roomId = isStringURL(value)
            ? extractRoomNameFromURL(value)
            : value

        if (roomId.length === 12) {
            setInputValue(roomId.toUpperCase())
            setIsValidRoomId(true)
            setErrorMessage('')
        } else {
            setIsValidRoomId(false)
            setErrorMessage('Please enter the correct room Id or meeting link')
        }
    }

    const navigateToRoom = e => {
        console.debug('navigate to Room now', inputValue)
        if (isValidRoomId) {
            navigate(`/${inputValue}`)
        }
    }

    const validationNode =
        errorMessage !== '' ? (
            <ValidationError>{errorMessage}</ValidationError>
        ) : null

    return (
        <OuterWrapper>
            <Wrapper>
                <LogoWrapper>
                    <Logo src="assets/revamp/logo-red.svg" />
                </LogoWrapper>
                <div>
                    <WelcomeText>
                        Welcome to <br />
                        Openhouse classes
                    </WelcomeText>
                    <SubText>
                        Join your class by entering a class code or link below
                    </SubText>
                    <InputWrapper>
                        <InputField
                            placeholder="Enter meeting code or link"
                            value={inputValue}
                            onChange={handleRoomIdChange}
                            onBlur={onBlur}
                        />
                    </InputWrapper>
                    {validationNode}
                </div>
                <ActionWrapper>
                    <Button disabled={!isValidRoomId} onClick={navigateToRoom}>
                        {' '}
                        Next{' '}
                    </Button>
                </ActionWrapper>
            </Wrapper>
        </OuterWrapper>
    )
}

export default EnterRoomId
